import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import {
	getObligationEstablishmentList,
	addNewObligationEstablishment,
	updateObligationEstablishment,
	deleteObligationEstablishment,
	getObligationEstablishment,
	ObligationEstablishmentUpdate,
	fetchCriticalityList,
	fetchComplianceList,
	fetchComplianceMatrix,
} from '../obligationEstablishment/thunk';

export const initialState = {
	itemObligationEstablishmentList: [],
	itemObligationEstablishmentDetail: null,
	isObligationEstablishmentLoading: false,
	isObligationEstablishmentSuccess: false,

	obligationEstablishmentList: [],
	obligationEstablishmentListSelect: [],
	fetchCriticalityList: [],
	fetchComplianceList: [],
	fetchComplianceMatrix: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
};

const ObligationEstablishmentSlice = createSlice({
	name: 'ObligationEstablishments',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getObligationEstablishment.fulfilled, (state, action) => {
			state.isObligationEstablishmentLoading = false;
			state.isObligationEstablishmentSuccess = true;
			state.itemObligationEstablishmentDetail = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getObligationEstablishment.pending, state => {
			state.isObligationEstablishmentLoading = true;
			state.isObligationEstablishmentSuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getObligationEstablishment.rejected, (state, action) => {
			state.isObligationEstablishmentLoading = false;
			state.isObligationEstablishmentSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});

		builder.addCase(getObligationEstablishmentList.pending, state => {
			state.isObligationEstablishmentSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getObligationEstablishmentList.fulfilled, (state, action) => {
			state.itemObligationEstablishmentList = action.payload;
			state.obligationEstablishmentList = action.payload;
			state.isLoadingList = false;
			state.isObligationEstablishmentSuccess = true;

			let obligationEstablishmentListSelect = [];
			action.payload.map(item =>
				obligationEstablishmentListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.obligationEstablishmentListSelect = obligationEstablishmentListSelect;
		});
		builder.addCase(getObligationEstablishmentList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isObligationEstablishmentSuccess = true;
		});
		builder.addCase(addNewObligationEstablishment.fulfilled, (state, action) => {
			state.itemObligationEstablishmentList.push(action.payload);
			state.obligationEstablishmentList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewObligationEstablishment.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewObligationEstablishment.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updateObligationEstablishment.fulfilled, (state, action) => {
			state.itemObligationEstablishmentList = state.itemObligationEstablishmentList.map(obligationEstablishment =>
				obligationEstablishment.obligationEstablishmentname === action.payload.old_obligationEstablishment
					? { ...obligationEstablishment, ...action.payload.updated_obligationEstablishment }
					: obligationEstablishment
			);
			state.obligationEstablishmentList = state.obligationEstablishmentList.map(obligationEstablishment =>
				obligationEstablishment._id.toString() === action.payload._id.toString()
					? { ...obligationEstablishment, ...action.payload }
					: obligationEstablishment
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updateObligationEstablishment.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateObligationEstablishment.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteObligationEstablishment.fulfilled, (state, action) => {
			state.itemObligationEstablishmentList = current(state.itemObligationEstablishmentList).filter(
				item => item._id !== action.payload._id
			);
			state.obligationEstablishmentList = current(state.obligationEstablishmentList).filter(item =>
				item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deleteObligationEstablishment.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deleteObligationEstablishment.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});

		builder.addCase(ObligationEstablishmentUpdate.fulfilled, (state, action) => {
			state.isObligationEstablishmentLoading = false;
			state.isObligationEstablishmentSuccess = true;
			state.itemObligationEstablishmentDetail = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(ObligationEstablishmentUpdate.pending, state => {
			state.isObligationEstablishmentLoading = true;
			state.isObligationEstablishmentSuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(ObligationEstablishmentUpdate.rejected, (state, action) => {
			state.isObligationEstablishmentLoading = false;
			state.isObligationEstablishmentSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});

		builder.addCase(fetchCriticalityList.fulfilled, (state, action) => {
			state.isObligationEstablishmentLoading = false;
			state.isObligationEstablishmentSuccess = true;
			state.fetchCriticalityList = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(fetchCriticalityList.pending, state => {
			state.isObligationEstablishmentLoading = true;
			state.isObligationEstablishmentSuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(fetchCriticalityList.rejected, (state, action) => {
			state.isObligationEstablishmentLoading = false;
			state.isObligationEstablishmentSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});

		builder.addCase(fetchComplianceList.fulfilled, (state, action) => {
			state.isObligationEstablishmentLoading = false;
			state.isObligationEstablishmentSuccess = true;
			state.fetchComplianceList = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(fetchComplianceList.pending, state => {
			state.isObligationEstablishmentLoading = true;
			state.isObligationEstablishmentSuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(fetchComplianceList.rejected, (state, action) => {
			state.isObligationEstablishmentLoading = false;
			state.isObligationEstablishmentSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});

		builder.addCase(fetchComplianceMatrix.fulfilled, (state, action) => {
			state.isObligationEstablishmentLoading = false;
			state.isObligationEstablishmentSuccess = true;
			state.fetchComplianceMatrix = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(fetchComplianceMatrix.pending, state => {
			state.isObligationEstablishmentLoading = true;
			state.isObligationEstablishmentSuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(fetchComplianceMatrix.rejected, (state, action) => {
			state.isObligationEstablishmentLoading = false;
			state.isObligationEstablishmentSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});
	},
});

export const { setRequireCloseModal } = ObligationEstablishmentSlice.actions;

export default ObligationEstablishmentSlice.reducer;
